
import SessionEventProto from "../session-event-proto";
import SessionCustomField from "../../model2/custom-field/session-custom-field";

export default class EventCustomFieldNew extends SessionEventProto {


    process() {

        if (!gd.session.customFields.get(this.data.id)) {
            gd.session.customFields.add(
                new SessionCustomField(this.data)
            )
        }

        gd.fields?.onNewCustomField(gd.session.customFields.get(this.data.id))

    }
}



// module.exports = class EventCustomFieldNew extends EventActionProto {
//
//     constructor(uid, data) {
//         super(uid, data);
//     }
//
//     validate() {
//         return true;
//     }
//
//     process() {
//         if (!gd.session.customFields.get(this.data.id)) {
//             gd.session.customFields.add([this.data],{parse:true});
//             // add
//         }
//
//         gd.fields?.onNewCustomField(gd.session.customFields.get(this.data.id))
//
//         super.process();
//     }
// };

